import { getControlDescription } from './hoverTooltipDescMap';
import { ActionControlId } from 'owa-ribbon-ids';

export function getHoverTooltip(
    controlId: ActionControlId,
    controlName: string
): string | undefined {
    const description: string | undefined = getControlDescription(controlId);

    if (description) {
        return `${controlName}\n\n${description}`;
    }

    return undefined;
}
